import { FC, useState } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import styled from './index.module.scss';
import CheckedIcon from './Icon';
import Emarsys from '@/components/MembersDay/FY2024/Emarsys';
import { EU_SITES, currentEmailSource, zaNewProductSource, euEmailSource } from '@/constants/membersday';
import getLocal from '@/app/utils/getLocal';
import gtm from '@/utils/gtm';
import { useLang } from '@/i18n';
import { getPrivacyPolicy } from '@/utils/common';

// const hasCheckBoxLocal = ['za', 'au', 'kr'];
interface IProps {
    newProductSub?: boolean; // 新品订阅
}

const Subscribe: FC<IProps> = ({ newProductSub }) => {
    const { locale } = getLocal();
    const { t } = useLang('membersday.subscribe');
    const [checked, setChecked] = useState(['us', 'jp', 'au', 'kr', 'za'].includes(locale) ? true : false);
    // source字段
    let source = '25 EcoCredits Day';
    if (EU_SITES.includes(locale)) source = euEmailSource.teaser;
    if (newProductSub && locale === 'za') source = zaNewProductSource;
    if (locale === 'au') source = zaNewProductSource;

    const successCallBack = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('btnText'),
                status: 'success',
                tag: 'Agree',
            });
        } catch (e) {
            console.error(e);
        }
    };

    const errorCallback = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_submit',
            button_name: t('btnText'),
            status: 'fail',
            tag: 'Agree',
        });
    };

    return (
        <div className={`${styled.Subscribe} ${newProductSub ? 'product_sub' : ''}`}>
            {newProductSub ? (
                <EditorImg
                    pc={
                        'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711444499013/%E5%9B%BE%E5%B1%82-13%20%E6%8B%B7%E8%B4%9D%201_1711444487.jpg'
                    }
                    h5={'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711444717567/Frame%201000008100_1711444710.jpg'}
                />
            ) : (
                <EditorImg
                    pc={'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1710667257193/Sign%20upjpg.jpg'}
                    h5="https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1710667308935/Sign%20upjpg.jpg"
                    alt={''}
                />
            )}

            <div className="subscribe_box">
                <h5 className="subscribe_title">{newProductSub ? t('title_newproduct') : t('title')}</h5>
                <div className="email-box">
                    <Emarsys
                        source={source}
                        submitText={t('btnText')}
                        placeholder={t('placeholder')}
                        successCallback={successCallBack}
                        errorCallback={errorCallback}
                        checked={checked}
                    />
                    <p className="protocol">
                        <span className={`check ${checked && 'checked'}`} onClick={() => setChecked(!checked)}>
                            {checked && <CheckedIcon />}
                        </span>
                        {t.rich('protocol', {
                            line1: (text: string) => {
                                const defaultUrl = getPrivacyPolicy(locale);
                                const linkMap: Record<string, string> = {
                                    jp: 'https://account.ecoflow.com/agreement/ja-jp/PrivacyPolicy.html',
                                };
                                const link = linkMap[locale] ? linkMap[locale] : defaultUrl;
                                return (
                                    <a className="link" href={link} target="_blank" rel="noreferrer">
                                        {text}
                                    </a>
                                );
                            },
                            line2: (text: string) => {
                                const defaultUrl = `https://${locale}.ecoflow.com/policies/terms-of-service`;
                                const linkMap: Record<string, string> = {
                                    jp: 'https://account.ecoflow.com/agreement/ja-jp/TermsOfUse.html',
                                };
                                const link = linkMap[locale] ? linkMap[locale] : defaultUrl;
                                return (
                                    <a className="link" href={link} target="_blank" rel="noreferrer">
                                        {text}
                                    </a>
                                );
                            },
                        })}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Subscribe;
